<template>
  <div class="mb-3 card card-sm card-choice">
    <div class="card-header">
      {{ title }}
      <template v-if="choice">
        <button
          class="ms-auto btn btn-sm btn-success"
          @click.prevent="emit('change-choice')"
        >
          Change
        </button>
        <button
          class="ms-2 btn btn-sm btn-danger"
          @click.prevent="emit('remove-choice')"
        >
          Remove
        </button>
      </template>
    </div>
    <div
      v-if="choice"
      class="card-body"
    >
      <div
        v-if="hasErrorMessages"
        class="alert alert-danger"
      >
        <h4>Validation errors</h4>
        <hr>
        <ul>
          <li
            v-for="(message, messageIdx) of choice.errorMessages"
            :key="messageIdx"
          >
            {{ message }}
          </li>
        </ul>
      </div>
      <div class="row">
        <dl class="col col-4">
          <dt>Institution</dt>
          <dd>{{ choice.institutionName }}</dd>
        </dl>
        <dl class="col col-4">
          <dt>Available places</dt>
          <dd>{{ choice.availablePlaces }}</dd>
        </dl>
        <div
          v-if="choice.durationItems.length"
          class="mb-2 col-4"
        >
          <label class="form-label required">Length</label>
          <select
            v-model="choice.durationId"
            class="form-select form-select-sm"
          >
            <option
              v-for="duration of choice.durationItems"
              :key="duration.id"
              :value="duration.id"
            >
              {{ duration.name }}
            </option>
          </select>
        </div>
      </div>
      <div
        v-if="isCJEU && hasCjeuAllocations"
        class="row"
      >
        <div class="mb-2 col">
          <label class="form-label required">Please specify indicative preference of allocation</label>
          <select
            v-model="choice.cjeuAllocationId"
            class="form-select form-select-sm"
          >
            <option />
            <option
              v-for="cjeuAllocation of choice.cjeuAllocationItems"
              :key="cjeuAllocation.id"
              :value="cjeuAllocation.id"
            >
              {{ cjeuAllocation.name }}
            </option>
          </select>
        </div>
      </div>
      <hr>
      <div>
        <label class="form-label mb-2">Please indicate any special interest (ie. specialisation)</label>
        <input
          v-model="choice.specialInterest"
          type="text"
          class="form-control form-control-sm"
        >
      </div>
    </div>
    <div
      v-else
      class="card-body m-4 text-center"
    >
      <button
        type="button"
        class="btn btn-info"
        @click.prevent="emit('change-choice')"
      >
        Select training institution and period
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import {computed} from 'vue'
import type {OspeExchangeChoice} from "@/js/ospe-types";

defineProps({
  title: {type: String, default: ''}
})

const choice = defineModel<OspeExchangeChoice | null>('choice', {required: true})

const emit = defineEmits<{
  'change-choice': []
  'remove-choice': []
}>()

const hasErrorMessages = computed(() => {
  return Array.isArray(choice.value?.errorMessages)
    && choice.value.errorMessages.length > 0
})

const isCJEU = computed(() => {
  return choice.value?.institutionTag === 'CJEU'
})

const hasCjeuAllocations = computed(() => {
  return Array.isArray(choice.value?.cjeuAllocationItems)
    && choice.value.cjeuAllocationItems.length > 0
})
</script>
